import {DebuggingComponent} from '@fantasmagames/slot/src/common/debugging/DebuggingComponent';
import {BackgroundView} from '@fantasmagames/slot/src/modules/background/BackgroundView';
import {ScreenEvents} from '@fantasmagames/core/src/screen/ScreenEvents';

export class BackgroundDebuggingComponent extends DebuggingComponent {
	public init(): void {
		super.init();

		this.setupInput();

		this.addKeyFunction('KeyV', 'shakeBackground', () => {
		});
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/background/debuggingComponent/BackgroundDebuggingComponent.ts